import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LoginService } from './service/login.service';
import validationform from '../../validation/validationform';
import * as CryptoJS from 'crypto-js';
import { NotifierService } from 'angular-notifier';
import { Router } from '@angular/router';
import { VerifyService } from '../verify/service/verify.service';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {

  showBtn = signal<Boolean>(false);
  spinner = signal<Boolean>(false);
  loginSubmitted = signal<Boolean>(false);
  getEmailVerifyResponseData:any;
  permitedEmail: any;
  showVerifyForm = 'login';
  otpInput: any;
  otpVerifiedData:any;
  type: string = 'password';
  isText = false;
  eyeIcon = 'fa-eye-slash';
  passwordIcon = 'fa fa-lock';
  loginForm:FormGroup=new FormGroup({});

  captchaText: string = '';
captchaInput: string = '';
captchaVerified: boolean = false;
captchaSubmitted: boolean = false;
captchaReady = signal<boolean>(false);

  @Input() ReceiveSignUpVerify: any;
  @Output() formChange:EventEmitter<any>=new EventEmitter();
  private readonly notifier: NotifierService;
  constructor(private service:LoginService,private verifyService:VerifyService, private notifierService: NotifierService,private router:Router){
    this.notifier = notifierService;
  }

  ngOnInit(){
    this.loginForm = new FormGroup({
      email: new FormControl(null, [Validators.required,Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]),
      pwd: new FormControl(null, [
        Validators.required,
        Validators.pattern(
          '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-zd$@$!%*?&].{8,}'
        ),
      ]),
    });
    this.loginSubmitted.set(false);
    this.captchaReady.set(false);
  }

  hideShowPassword() {
    this.isText = !this.isText;
    this.isText ? (this.eyeIcon = 'fa-eye') : (this.eyeIcon = 'fa-eye-slash');
    this.isText ? (this.type = 'text') : (this.type = 'password');
  }

  // validateUserEmail() {
  //   const value = this.loginForm.value;
  //   const emailId = value.email;
  //   this.loginSubmitted.set(true);
  //   if (this.loginForm.controls['email'].valid) {
  //     this.spinner.set(true);
  //     this.service.getData().subscribe((sub:any) => {});
  //     this.service.getEmail(emailId).subscribe({
  //       next:(sub: any) => {
  //         this.loginSubmitted.set(false);
  //         localStorage.setItem('loginuser', sub['email']);
        
  //       this.getEmailVerifyResponseData = sub;
  //         this.permitedEmail = this.getEmailVerifyResponseData.email;
  //         if (!this.getEmailVerifyResponseData.password_reset) {
  //           this.showVerifyForm = 'verify';
  //           this.formChange.emit(this.showVerifyForm);
  //           // this.otpInput=sub['otp'];
  //           // this.submitOtp();
  //         }
  //         if (this.getEmailVerifyResponseData.password_reset && this.getEmailVerifyResponseData.is2faenabled) {
  //           this.service.twoFactorLogin(emailId).subscribe({
  //             next:(res:any)=>{
  //            this.showVerifyForm = 'verify';
  //            this.formChange.emit(this.showVerifyForm);
  //            this.notifier.notify('default', 'A verification code has been sent to your registered email and mobile.');
  //           },error:(error:HttpErrorResponse)=>{
  //           }});
           
  //           this.ReceiveSignUpVerify = this.showVerifyForm;
  //         }  
  //         this.spinner.set(false);
  //         this.showBtn.set(true);
  //         this.generateCaptcha();
  //       },
  //       error:(error:any) => {
  //         this.spinner.set(false);
  //       }
  //   });
  //   } else {
  //     validationform.ValidateAllFormFields(this.loginForm);
  //   } 
  // }

//   validateUserEmail() {
//   const value = this.loginForm.value;
//   const emailId = value.email;
//   this.loginSubmitted.set(true);

//   if (this.loginForm.controls['email'].valid) {

//     // ── CAPTCHA CHECK ──────────────────────────────────────────
//     // If captcha is showing (password field visible), verify first
//     if (this.captchaReady() && !this.captchaVerified) {
//       this.captchaSubmitted = true;
//       return; // ← block — don't proceed until captcha is correct
//     }
//     // ──────────────────────────────────────────────────────────

//     this.spinner.set(true);
//     this.service.getEmail(emailId).subscribe({
//       next: (sub: any) => {
//         this.loginSubmitted.set(false);
//         localStorage.setItem('loginuser', sub['email']);
//         this.getEmailVerifyResponseData = sub;
//         this.permitedEmail = this.getEmailVerifyResponseData.email;

//         if (!this.getEmailVerifyResponseData.password_reset) {
//           this.showVerifyForm = 'verify';
//           this.formChange.emit(this.showVerifyForm);
//         }

//         if (
//           this.getEmailVerifyResponseData.password_reset &&
//           this.getEmailVerifyResponseData.is2faenabled
//         ) {
//           this.service.twoFactorLogin(emailId).subscribe({
//             next: (res: any) => {
//               this.showVerifyForm = 'verify';
//               this.formChange.emit(this.showVerifyForm);
//               this.notifier.notify('default', 'A verification code has been sent to your registered email and mobile.');
//             },
//             error: (error: HttpErrorResponse) => {}
//           });
//           this.ReceiveSignUpVerify = this.showVerifyForm;
//         }

//         this.spinner.set(false);
//         this.showBtn.set(true);

//         // ── REGENERATE CAPTCHA for password step ───────────────
//         this.captchaReady.set(true);
//         this.generateCaptcha(); // ← fresh captcha for next step
//         // ──────────────────────────────────────────────────────
//       },
//       error: (error: any) => {
//         this.spinner.set(false);
//       }
//     });

//   } else {
//     validationform.ValidateAllFormFields(this.loginForm);
//   }
// }

validateUserEmail() {
  const value = this.loginForm.value;
  const emailId = value.email;

  this.loginSubmitted.set(true);

  if (this.loginForm.controls['email'].valid) {

    // CAPTCHA CHECK
    if (this.captchaReady() && !this.captchaVerified) {
      this.captchaSubmitted = true;
      return;
    }

    this.spinner.set(true);

    this.service.getEmail(emailId).subscribe({
      next: (sub: any) => {
        this.loginSubmitted.set(false);

        localStorage.setItem('loginuser', sub.email);

        this.getEmailVerifyResponseData = sub;
        this.permitedEmail = sub.email;

        // Hide password field by default
        this.showBtn.set(false);

        // Flow 1: Email verification required
        if (!sub.password_reset) {
          this.showVerifyForm = 'verify';
          this.formChange.emit(this.showVerifyForm);
        }

        // Flow 2: 2FA enabled → directly send OTP
        else if (sub.password_reset && sub.is2faenabled) {

          this.service.twoFactorLogin(emailId).subscribe({
            next: (res: any) => {
              this.showVerifyForm = 'verify';
              this.formChange.emit(this.showVerifyForm);

              this.notifier.notify(
                'default',
                'A verification code has been sent to your registered email and mobile.'
              );
            },
            error: (error: HttpErrorResponse) => {
              console.error(error);
            }
          });

          this.ReceiveSignUpVerify = this.showVerifyForm;
        }

        // Flow 3: Normal login → show password field
        else {
          this.showBtn.set(true);

          // Generate captcha for password step
          this.captchaReady.set(true);
          this.generateCaptcha();
        }

        this.spinner.set(false);
      },

      error: (error: any) => {
        this.spinner.set(false);
        console.error(error);
      }
    });

  } else {
    validationform.ValidateAllFormFields(this.loginForm);
  }
}


  makeRandom(lengthOfCode: number, possible: string) {
    let text = '';
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  // submitOtp() {
  //   this.spinner.set(true);
  //   const otpPayload = {
  //     is2fa: this.getEmailVerifyResponseData?.is2faenabled ? true : false,
  //     verifyotp: this.otpInput?.toString().trim(),
  //   };

  //   this.service.postOtp(otpPayload).subscribe({
  //     next: (response) => {
  //       this.otpVerifiedData = response;
  //       const token = this.otpVerifiedData.token;
  //       const userid = this.otpVerifiedData.userid;
  //       localStorage.setItem('loginuser', userid);
  //       sessionStorage.setItem('token', token);
  //       if (this.ReceiveSignUpVerify === 'verify') {
  //        // this.route.navigate(['audioRecords']);
  //        // this.showComp.emit({ make: true, name: 'signUp' });
  //       } else {
  //         this.showVerifyForm = 'otp';
  //       }
  //       this.spinner.set(false);
  //     },
  //     error: (err) => {
  //       this.spinner.set(false);
  //     },
  //   });
  // }
  submitOtp() {
  // ── CAPTCHA GUARD ──────────────────────────
  this.captchaSubmitted = true;
  if (!this.captchaVerified) return; // ← block OTP submit until captcha passes
  // ──────────────────────────────────────────

  this.spinner.set(true);
  const otpPayload = {
    is2fa: this.getEmailVerifyResponseData?.is2faenabled ? true : false,
    verifyotp: this.otpInput?.toString().trim(),
  };

  this.service.postOtp(otpPayload).subscribe({
    next: (response) => {
      this.otpVerifiedData = response;
      const token = this.otpVerifiedData.token;
      const userid = this.otpVerifiedData.userid;
      localStorage.setItem('loginuser', userid);
      sessionStorage.setItem('token', token);
      if (this.ReceiveSignUpVerify === 'verify') {
      } else {
        this.showVerifyForm = 'otp';
      }
      this.spinner.set(false);
    },
    error: (err) => {
      this.spinner.set(false);
    },
  });
}



  signIn() {
    this.captchaSubmitted = true;          
  if (!this.captchaVerified) return;     
    this.loginSubmitted.set(true);
    if(this.loginForm.controls['pwd'].valid) {
    const values = this.loginForm.value;
    const email = values.email.trim();
    const password = values.pwd.trim();
    const possible =  "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890,./;'[]=-)(*&^%$#@!~`";
    const dynamic_str = this.makeRandom(16, possible);
    const salt = this.makeRandom(16, possible);
    const iterations = 128;
    const bytes = CryptoJS.PBKDF2(dynamic_str, salt, {
      keySize: 48,
      iterations: iterations,
    });
    const iv = CryptoJS.enc.Hex.parse(bytes.toString().slice(0, 32));
    const key = CryptoJS.enc.Hex.parse(bytes.toString().slice(32, 96));

    const ciphertext = CryptoJS.AES.encrypt(password, key, { iv: iv });
    const formEncript = {
      email: email.trim(),
      encrypted_data: ciphertext.toString(),
      salt: salt,
      pass_phrase: dynamic_str,
    };
   
      this.spinner.set(true);
      this.service.postEmail(formEncript).subscribe({
       next: (result:any) => {
         // this.localValue = sub;
          //const token = this.localValue.token;
          this.verifyService.verifyToken="";
          if(result.hasOwnProperty("is2faenabled")){
               if(result.is2faenabled){
                let emailId = result['email'];
                   this.service.twoFactorLogin(emailId).subscribe({
                    next:(res:any)=>{
                     this.showVerifyForm = 'verify';
                     this.formChange.emit(this.showVerifyForm);
                      //  reset captcha for the upcoming OTP submission
                      this.captchaVerified = false;
                      this.captchaInput = '';
                      this.captchaSubmitted = false;
                      this.generateCaptcha(); // fresh captcha for OTP screen
                    },
                    error:(errors:HttpErrorResponse)=>{

                    }});
               }
          }
          localStorage.setItem(
            'loginuser',
            email
          );
          sessionStorage.setItem('token', result['token']);
          this.service.getUser().subscribe({next:(response:any)=>{
              var data = CryptoJS.AES.encrypt(JSON.stringify(response),this.service.enCryptKey);
              localStorage.setItem("user",data.toString());
               this.service.isAuthorizedUser=true;
              // this.showComp.emit({ make: true, name: 'login' });
                this.router.navigateByUrl("dashboard");
               this.spinner.set(false);
          },error:(error:HttpErrorResponse)=>{
          }});
         
          this.isText = false;
        },
        error:(error) => {
          this.spinner.set(false);
        }
       });
    } else {
      this.spinner.set(false);
    }
  }


  signUp(){
    this.formChange.emit("signup");
  }

  forgotpass(){
    this.formChange.emit('forgotpass');
  }

generateCaptcha(): void {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
  this.captchaText = Array.from(
    { length: 6 },
    () => chars[Math.floor(Math.random() * chars.length)]
  ).join('');
  this.captchaVerified = false;
  this.captchaInput = '';
  this.captchaSubmitted = false;

  // Use requestAnimationFrame — waits for Angular to finish rendering the DOM
  requestAnimationFrame(() => {
    requestAnimationFrame(() => this.drawCaptcha()); // double-rAF ensures DOM is painted
  });
}

drawCaptcha(): void {
  const canvas = document.getElementById('captchaCanvas') as HTMLCanvasElement;
  if (!canvas) return;
  const ctx = canvas.getContext('2d')!;

  canvas.width = 180;
  canvas.height = 44;

  // Clean white background — matches the input field
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, 180, 44);

  // Subtle noise lines
  for (let i = 0; i < 4; i++) {
    ctx.beginPath();
    ctx.moveTo(Math.random() * 180, Math.random() * 44);
    ctx.lineTo(Math.random() * 180, Math.random() * 44);
    ctx.strokeStyle = `hsla(${Math.random() * 360}, 30%, 75%, 0.5)`;
    ctx.lineWidth = 1;
    ctx.stroke();
  }

  // Letters — use system-ui to match Bootstrap/form font
  const colors = ['#1a56db','#0f6e56','#993c1d','#534ab7','#72243e','#3b6d11'];
  this.captchaText.split('').forEach((ch, i) => {
    ctx.save();
    const x = 18 + i * 26;
    const y = 28 + (Math.random() * 6 - 3);
    ctx.translate(x, y);
    ctx.rotate((Math.random() - 0.5) * 0.35);  // subtle tilt, not extreme
    ctx.font = `600 20px system-ui, -apple-system, sans-serif`;  // matches form font weight
    ctx.fillStyle = colors[i % colors.length];
    ctx.fillText(ch, 0, 0);
    ctx.restore();
  });

  // Subtle noise dots
  for (let i = 0; i < 25; i++) {
    ctx.beginPath();
    ctx.arc(Math.random() * 180, Math.random() * 44, 0.8, 0, 2 * Math.PI);
    ctx.fillStyle = 'rgba(0,0,0,0.06)';
    ctx.fill();
  }
}

verifyCaptcha(): void {
  this.captchaVerified =
    this.captchaInput.trim() === this.captchaText;
}

}
